import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Mail/hooks/useMailMessages.ts
function useMailMessages(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Mail.GetMessagesList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useMailMessages };

//# sourceMappingURL=useMailMessages.js.map